import { useEffect, useState } from "react";
import { db } from "../firebase";
import { collection, getDocs } from "firebase/firestore";
import { FaChartBar, FaProjectDiagram, FaInfoCircle } from "react-icons/fa";

function ProjectList() {
  const [projects, setProjects] = useState([]);
  const projectsCollection = collection(db, "projects");

  const fetchProjects = async () => {
    const data = await getDocs(projectsCollection);
    setProjects(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
  };

  useEffect(() => {
    fetchProjects();
  }, []);

  const getStatusColor = (status) => {
    switch (status.toLowerCase()) {
      case "live":
        return "#e53935"; // Red
      case "completed":
        return "#43a047"; // Green
      case "on hold":
        return "#fbc02d"; // Yellow
      default:
        return "#757575"; // Grey
    }
  };

  const getStatusIcon = (status) => {
    switch (status.toLowerCase()) {
      case "live":
        return <FaInfoCircle style={{ marginRight: "6px" }} />;
      case "completed":
        return <FaProjectDiagram style={{ marginRight: "6px" }} />;
      case "on hold":
        return <FaChartBar style={{ marginRight: "6px" }} />;
      default:
        return <FaInfoCircle style={{ marginRight: "6px" }} />;
    }
  };

  return (
    <div
      style={{
        padding: "30px",
        paddingTop:"60px",
        marginTop: "65px",
        maxWidth: "1200px",
        margin: "40px auto 0 auto",
        backgroundColor: "#121212",
        minHeight: "100vh",
        color: "#f1f1f1",
        fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
      }}
    >
      <h2
        style={{
          fontSize: "36px",
          fontWeight: "700",
          marginBottom: "40px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "12px",
          background: "linear-gradient(to right, #00bcd4, #aa3a61)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
        }}
      >
        <FaChartBar style={{ color: "#00bcd4" }} />
        Project Availability
      </h2>

      {projects.length === 0 ? (
        <p style={{ textAlign: "center", fontSize: "18px", color: "#ccc" }}>
          No projects uploaded yet.
        </p>
      ) : (
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
            gap: "24px",
          }}
        >
          {projects.map((project) => (
            <div
              key={project.id}
              style={{
                backgroundColor: "#1e1e1e",
                borderRadius: "12px",
                boxShadow: "0 6px 16px rgba(0,0,0,0.5)",
                padding: "24px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                textAlign: "center",
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "scale(1.04)";
                e.currentTarget.style.boxShadow = "0 8px 20px rgba(0,0,0,0.6)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "scale(1)";
                e.currentTarget.style.boxShadow = "0 6px 16px rgba(0,0,0,0.5)";
              }}
            >
              <div
                style={{
                  width: "220px",
                  height: "160px",
                  marginBottom: "20px",
                  borderRadius: "10px",
                  backgroundColor: "#2a2a2a",
                  backgroundImage: `url(${project.logo})`,
                  backgroundSize: "100% 100%",
                  backgroundPosition: "center",
                  backgroundRepeat: "no-repeat",
                  boxShadow: "inset 0 0 8px rgba(0,0,0,0.4)",
                }}
              ></div>

              <h3
                style={{
                  marginBottom: "8px",
                  fontSize: "20px",
                  color: "#00bcd4",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                <FaProjectDiagram />
                Project Name
              </h3>
              <p style={{ marginBottom: "20px", fontSize: "17px", fontWeight: "500" }}>
                {project.name}
              </p>
              <h3
                style={{
                  marginBottom: "8px",
                  fontSize: "18px",
                  color: "#aa3a61",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                <FaInfoCircle />
                Status
              </h3>
              <p
                style={{
                  fontSize: "15px",
                  fontWeight: "600",
                  color: "#fff",
                  backgroundColor: getStatusColor(project.status),
                  padding: "6px 16px",
                  borderRadius: "30px",
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "6px",
                  textTransform: "capitalize",
                  boxShadow: "0 2px 6px rgba(0,0,0,0.3)",
                }}
              >
                {getStatusIcon(project.status)}
                {project.status}
              </p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default ProjectList;
